<template>
  <a-typography-title :level="1">
    社区开发者将获得哪些权益？
  </a-typography-title>
  <section class="reward">
    <div class="container">
      <a-row :gutter="[20,20]">
        <a-col v-for="(item,index) in expand.list"
               :xs="12" :lg="6">
          <div class="item" :class="`i_${index+1}`">
            <div class="box_icon"><i /></div>
            <a-typography-title :level="5">
              {{ item }}
            </a-typography-title>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'community_reward',
  data(): DataInterface {
    return {
      href: {
        github: 'https://github.com/galaxy-future'
      },
      expand: {
        list: [
          '提升个人技术影响力',
          '深度参与产品技术研讨',
          '参加社区线下定期沙龙',
          '尊享专属活动礼遇'
        ]
      }
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/community/';

.creatAnimation(am_fade, {
  0% {
    opacity: 0;
    .transform(translate(-50%, -50%) scale(1));
  }
  20% {
    opacity: 1;
    .transform(translate(-50%, -50%) scale(1.15));
  }
  40% {
    opacity: 0;
    .transform(translate(-50%, -50%) scale(1.3));
  }
  100% {
    opacity: 0;
    .transform(translate(-50%, -50%) scale(1));
  }
});

.reward {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space_mo 0 @space;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  padding: @space @padding;
  margin: 0;
  .bg('@{image}background.png');
  background-size: cover;
  .font(center, @title, @color_white, @title, true);
  .fontSpacing(5px);
}

.item {
  @wh: 80px;
  position: relative;
  .borderBox();
  cursor: pointer;
  
  .loop(@i) when (@i<=4) {
    &.i_@{i} {
      .box_icon {
        &::before {
          background-position: -@wh*(-1+@i);
        }
      }
    }
    
    .loop(@i+1);
  }
  .loop(1);
  
  &:hover .box_icon i {
    &::before {
      .animation(am_fade 3s 0s linear infinite forwards);
    }
    
    &::after {
      .animation(am_fade 3s 0.7s linear infinite forwards);
    }
  }
  
  .box_icon {
    position: relative;
    width: @wh*2;
    height: @wh*2;
    margin: 0 auto;
    border-radius: 50%;
    border: 1px solid fade(@color_6, 10);
    pointer-events: none;
    
    &::before,
    &::after {
      content: '';
      display: block;
      .position();
      margin: auto;
    }
    
    &::before {
      width: @wh;
      height: @wh;
      .bg('@{image}reward_icon.png', @wh*4, @wh);
    }
    
    &::after {
      .center();
      width: -30px+@wh*2;
      height: -30px+@wh*2;
      border-radius: 50%;
      border: 1px solid @color_6;
    }
    
    i {
      display: block;
      .position();
      margin: auto;
      
      &::before,
      &::after {
        content: '';
        display: block;
        .center();
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 1px solid fade(@color_6, 10);
        opacity: 0;
      }
    }
  }
  
  h5.ant-typography {
    margin: @margin_mo 0 0;
    .font(center, @text_big, @color_12, @text_big, true);
  }
}

@media screen and (max-width: -1px+@grid_md) {
  h1.ant-typography {
    padding: @space_mo @padding_mo;
    .font(center, @title_mo, @color_white, @title_mo, true);
    .fontSpacing(0);
  }
  
  .reward {
    .container {
      padding: @space_mo 0;
    }
  }
  
  .item {
    @wh: 50px;
    
    .loop(@i) when (@i<=4) {
      &.i_@{i} {
        .box_icon {
          &::before {
            background-position: -@wh*(-1+@i);
          }
        }
      }
      
      .loop(@i+1);
    }
    .loop(1);
    
    .box_icon {
      width: @wh*2;
      height: @wh*2;
      
      &::before {
        width: @wh;
        height: @wh;
        .bg('@{image}reward_icon.png', @wh*4, @wh);
      }
      
      &::after {
        width: -30px+@wh*2;
        height: -30px+@wh*2;
      }
    }
    
    h5.ant-typography {
      padding: 0 20px;
      .font(center, @text_big_mo+@line_mo, @color_12, @text_big_mo, true);
    }
  }
}
</style>